// service/crm/hooks/useDownloadContactImportTemplateMutation.ts

import { useMutation } from "@tanstack/react-query";
import { contactImportApi } from "service/crm/api/contactImport";
import { CONTACT_IMPORT_MODULE, ContactImportModule } from "types/crm/contactImport";

/**
 * Fetches the blank import template.
 *
 * A mutation rather than a query: it runs when the button is pressed, and the
 * file it returns is handed to the browser rather than held in cache.
 */
export const useDownloadContactImportTemplateMutation = () =>
  useMutation<Blob, unknown, ContactImportModule | void>({
    mutationFn: (module) => contactImportApi.downloadTemplate(module || CONTACT_IMPORT_MODULE),
  });
